export const Reports= {
    CLEAR_SELECTION: "CLEAR_SELECTED",
    EXCEL_REPORT: "GENERATING_EXCEL_REPORT",
    EXCEL_REPORT_FOR_ONE_TENANT: "GENERATING_EXCEL_REPORT_FOR_SOURCES_WITH_ONE_TENANT",
    KYB_EXCEL_REPORT: "GENERATING_KYB_EXCEL_REPORT",
    ALL_TENANTS_EXCEL_REPORT: "ALL_TENANTS_EXCEL_REPORT",
    CSV_REPORT: "GENERATING_CSV_REPORT",
    KYB_CSV_REPORT: "GENERATING_KYB_CSV_REPORT",
    KYB_COUNTRY_COVERAGE_EXCEL_REPORT: "KYB_EXCEL_REPORT_BY_TYPE",
    PDF_REPORT: "GENERATING_PDF_REPORT",
    PDF_REPORT_FOR_ONE_TENANT: "PDF_REPORT_FOR_ONE_TENANT",
    KYB_PDF_REPORT: "GENERATING_KYB_PDF_REPORT",
    EXCEL_REPORT_SUCCESS: "EXCEL_REPORT_SUCCESS",
    CSV_REPORT_SUCCESS: "CSV_REPORT_SUCCESS",
    GET_COUNTRIES_SOURCES: "GET_COUNTRIES_SOURCES",
    GET_TENANTS_PRICING_DATA: "GET_TENANTS_PRICING_DATA",
    PDF_REPORT_SUCCESS: "PDF_REPORT_SUCCESS",
    RESET_PDF_PORTAL: "RESET_PDF_PORTAL"
};

export const ReportsType = {
    PDF: "pdf",
    XLSX: "xlsx",
    CSV: "csv"
};
